import { DayOfWeek } from 'constants/common'

/**
 */
export const profileDayOfWeekFilterOptions: ProviderFilter[] = [
  {
    id: DayOfWeek.MONDAY,
    type: 'day_of_week',
    value: 'Monday',
    description: null,
    priority: 1,
  },
  {
    id: DayOfWeek.TUESDAY,
    type: 'day_of_week',
    value: 'Tuesday',
    description: null,
    priority: 1,
  },
  {
    id: DayOfWeek.WEDNESDAY,
    type: 'day_of_week',
    value: 'Wednesday',
    description: null,
    priority: 1,
  },
  {
    id: DayOfWeek.THURSDAY,
    type: 'day_of_week',
    value: 'Thursday',
    description: null,
    priority: 1,
  },
  {
    id: DayOfWeek.FRIDAY,
    type: 'day_of_week',
    value: 'Friday',
    description: null,
    priority: 1,
  },
  {
    id: DayOfWeek.SATURDAY,
    type: 'day_of_week',
    value: 'Saturday',
    description: null,
    priority: 1,
  },
  {
    id: DayOfWeek.SUNDAY,
    type: 'day_of_week',
    value: 'Sunday',
    description: null,
    priority: 1,
  },
]

/** Comma-separated labels for multiselect pill summaries (visit type, time of day, etc.). */
export function summarizeProviderFilterSelection(
  selectedIds: string[],
  options: ProviderFilter[]
): string {
  if (!selectedIds.length || !options.length) {
    return ''
  }

  const byId = new Map(options.map((o) => [o.id, o]))

  const labels = selectedIds
    .map((id) => byId.get(id)?.value)
    .filter((v): v is string => !!v)

  return labels.join(', ')
}

export function summarizeProfileDayOfWeekSelection(
  selectedIds: string[]
): string {
  if (!selectedIds.length) {
    return ''
  }

  const order = profileDayOfWeekFilterOptions.map((o) => o.id)

  const labels = selectedIds
    .slice()
    .sort((a, b) => order.indexOf(a) - order.indexOf(b))
    .map(
      (id) =>
        profileDayOfWeekFilterOptions.find((o) => o.id === id)?.value ?? id
    )

  return labels.join(', ')
}
